import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { sortBy } from 'lodash';

import { Job, Response, SubService } from '../../models';
import { environment } from '../../../environments';
import { PrismHeaders } from '../../enums';

@Injectable()
export class QuoteService {
  
  private storedSubServiceQuotesBS: BehaviorSubject<any> = new BehaviorSubject<any>({});
  
  constructor(private http: HttpClient) {
  }
  
  storedSubServiceQuotes$(jobId): Observable<SubService[]> {
    return of(this.storedSubServiceQuotesBS.value[jobId]);
  }
  
  get storedSubServicesQuotesValue(): SubService[] {
    return this.storedSubServiceQuotesBS.value;
  }
  
  updateSubServiceQuoteData(jobId, quoteData) {
    const tempSubServiceData = this.storedSubServiceQuotesBS.value;
    tempSubServiceData[jobId] = quoteData;
    this.storedSubServiceQuotesBS.next(tempSubServiceData);
  }
  
  getAllServiceData(service) {
    return this.http.get<Response>(`${environment.apiBaseUrl}/GetQuotationData`)
      .pipe(
        map(response => {
          let sub_services;
          ({sub_services} = response.data[service]);
          const subservicesArray = Object
            .values(sub_services)
            .map((ss: any) => ({...{fullCost: ss.finalCost, display: ss.display}, amount: 0, selected: false}));
          return [...sortBy(subservicesArray, subservice => subservice.display)];
        })
      );
  }
  
  sendQuoteToMember(job: Job, selectedSubservices, quoteTotal) {
    const headers = new HttpHeaders()
      .set(PrismHeaders.FunctionHelperData, JSON.stringify({job, selectedSubservices, quoteTotal}));
    
    return this.http.post<Response>(`${environment.apiBaseUrl}/SendQuoteToMember`, this.storedSubServicesQuotesValue[job.id], {
      headers
    });
  }
}
